import type { StatutCandidature } from '@rh/shared';

export function dateHeure(iso: string): string {
  return new Date(iso).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Partagés avec les exports Excel de l'API : mêmes libellés à l'écran et dans le classeur.
export { LIBELLES_SOURCE, libelleSource, nomComplet } from '@rh/shared';

/** `AAAA-MM-JJ` → `JJ/MM/AAAA`. */
export function jourLisible(jour: string): string {
  return jour.split('-').reverse().join('/');
}

/**
 * Un champ `datetime-local` travaille en heure locale sans fuseau, l'API veut
 * un instant ISO : on convertit dans les deux sens avec le fuseau du poste.
 */
export function versChampLocal(iso: string | null): string {
  if (!iso) return '';
  const instant = new Date(iso);
  return new Date(instant.getTime() - instant.getTimezoneOffset() * 60_000)
    .toISOString()
    .slice(0, 16);
}

export function depuisChampLocal(valeur: string): string | null {
  return valeur ? new Date(valeur).toISOString() : null;
}

/** Heure du dernier appel, avec l'année seulement si ce n'est pas l'année en cours. */
export function libelleDernierAppel(iso: string, joignable: boolean | null, maintenant = new Date()): string {
  const instant = new Date(iso);
  const jour = instant.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    ...(instant.getFullYear() !== maintenant.getFullYear() ? { year: 'numeric' } : {}),
  });
  const heure = instant.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const issue = joignable === true ? ' · joint' : joignable === false ? ' · injoignable' : '';
  return `Appelé le ${jour} à ${heure}${issue}`;
}

/**
 * Classe du nom d'un candidat écarté : barré (demande du 2026-09-19). Le nom
 * reste lisible et la mention « Écarté » l'accompagne partout — le trait seul
 * ne dirait rien à un lecteur d'écran.
 */
export function classeNom(statut: StatutCandidature): string | undefined {
  return statut === 'ecarte' ? 'nom-ecarte' : undefined;
}
